const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'byte_size_first_touch_v1';

function readCurrentTouch() {
  const params = new URLSearchParams(window.location.search);
  return Object.fromEntries(UTM_KEYS.map((key) => [key, params.get(key) || '']));
}

export function getAttribution() {
  const current = readCurrentTouch();
  const hasCampaign = UTM_KEYS.some((key) => current[key]);
  let first = null;

  try {
    first = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
  } catch {
    first = null;
  }

  if (!first) {
    first = {
      ...current,
      landing_page: window.location.href,
      referrer: document.referrer || '',
      captured_at: new Date().toISOString(),
    };
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(first));
    } catch {
      // Attribution remains available for this submission when storage is blocked.
    }
  }

  return {
    ...current,
    landing_page: window.location.href,
    referrer: document.referrer || '',
    first_utm_source: first.utm_source || '',
    first_utm_medium: first.utm_medium || '',
    first_utm_campaign: first.utm_campaign || '',
    first_utm_content: first.utm_content || '',
    first_utm_term: first.utm_term || '',
    first_landing_page: first.landing_page || '',
    first_referrer: first.referrer || '',
    has_campaign: hasCampaign ? 'yes' : 'no',
  };
}
